// import React, { useState } from "react";
// import loginLogo from "../../Assets/Images/login-logo.png";
// import "../../Assets/Images/loginPage-banner.jpg";
// import "../../Pages/LoginPage/LoginPage.scss";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import Cookies from "js-cookie";
// import { API_BASE_URL } from "../../utils/index";
// import Swal from "sweetalert2";
// import { FaEye, FaEyeSlash } from "react-icons/fa";

// export default function VendorLogin() {
//   const { id } = useParams();

//   console.log(id, "id");
//   const [email, setEmail] = useState("");
//   const [verifyPassword, setVerifyPassword] = useState("");
//   const [hide, setHide] = useState(false);
//   localStorage.setItem("vendorsubdomain", id);
//   const navigate = useNavigate();

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!email || !verifyPassword) {
//       Swal.fire({
//         icon: "warning",
//         title: "All fields are required",
//       });
//       return;
//     }

//     axios
//       .post(`${API_BASE_URL}/vendor/${id}/login`, {
//         email: email,
//         password: verifyPassword,
//       })
//       .then((result) => {
//         console.log(result, "result");

//         const isFirstLogin = result.data.vendor.isFirstLogin;
//         const adminId = result.data?.token;
//         localStorage.setItem("vendorsccesstoken", adminId);
//         localStorage.setItem("vendorsrefreshtoken", result.data.refreshToken);
//         console.log("Login Success", result.data);
//         navigate(isFirstLogin ? `/${id}/change-password` : `/${id}/dashboard/`);
//         Swal.fire({
//           icon: "success",
//           title: "Login Success",
//           showConfirmButton: false,
//           timer: 1500,
//         });
//       })
//       .catch((error) => {
//         console.log("Login Error", error);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: error?.response?.data?.message || "Something went wrong!",
//         });
//       });
//   };

//   return (
//     <div className="login-page d-flex align-items-center">
//       <div className="container">
//         <div className="row">
//           {/* Left side - Logo */}
//           <div className="col-md-6">
//             <div className="login-logor text-center">
//               <img src={loginLogo} alt="Login Logo" />
//             </div>
//           </div>

//           {/* Right side - Login form */}
//           <div className="col-md-6">
//             <form className="right" onSubmit={handleSubmit}>
//               <p className="login-title">Login into your account</p>
//               {/* Email input */}
//               <div className="my-2">
//                 <label htmlFor="email" className="form-label">
//                   Email Address
//                 </label>
//                 <input
//                   className="form-control"
//                   type="email"
//                   id="email"
//                   placeholder="Enter your email"
//                   autoComplete="email"
//                   required
//                   onChange={(e) => setEmail(e.target.value)}
//                 />
//               </div>
//               {/* Password input */}
//               <div className="my-2">
//                 <label htmlFor="password-field" className="form-label">
//                   Password
//                 </label>
//                 <div className="input-group" style={{ width: "60%" }}>
//                   <input
//                     id="password-field"
//                     type={hide ? "text" : "password"}
//                     className="form-control"
//                     name="password"
//                     value={verifyPassword}
//                     placeholder="Enter your password"
//                     autoComplete="current-password"
//                     required
//                     onChange={(e) => setVerifyPassword(e.target.value)}
//                   />
//                   <span
//                     className="input-group-text color-black"
//                     onClick={() => setHide(!hide)}
//                     style={{ cursor: "pointer", color: "black" }}
//                   >
//                     {hide ? (
//                       <i>
//                         <FaEye />
//                       </i>
//                     ) : (
//                       <i>
//                         <FaEyeSlash />
//                       </i>
//                     )}
//                   </span>
//                 </div>
//               </div>
//               {/* Submit button */}
//               <div className="mt-3">
//                 <button type="submit" className="btn submit-button w-25">
//                   Login
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  IconButton,
  Typography,
  InputAdornment,
  Paper,
  Container,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import loginLogo from "../../Assets/Images/login-logo.png";
import { API_BASE_URL } from "../../utils/index";

export default function VendorLogin() {
  const { id } = useParams();
  const [email, setEmail] = useState("");
  const [verifyPassword, setVerifyPassword] = useState("");
  const [hide, setHide] = useState(false);
  const navigate = useNavigate();

  localStorage.setItem("vendorsubdomain", id);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email || !verifyPassword) {
      Swal.fire({
        icon: "warning",
        title: "All fields are required",
      });
      return;
    }

    axios
      .post(`${API_BASE_URL}/vendor/${id}/login`, {
        email,
        password: verifyPassword,
      })
      .then((result) => {
        const isFirstLogin = result.data.vendor.isFirstLogin;
        const adminId = result.data?.token;
        localStorage.setItem("vendorsccesstoken", adminId);
        localStorage.setItem("vendorsrefreshtoken", result.data.refreshToken);

        navigate(isFirstLogin ? `/${id}/change-password` : `/${id}/dashboard/`);
        Swal.fire({
          icon: "success",
          title: "Login Success",
          showConfirmButton: false,
          timer: 1500,
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.response?.data?.message || "Something went wrong!",
        });
      });
  };

  return (

    <Box

      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        // background: "#f5f5f5",
      }}
      className="login-page"
    >
      <Container>
        <Grid container justifyContent="center" spacing={4}>
          {/* Left Column: Logo */}
          <Grid item xs={12} md={6} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Box component="img" src={loginLogo} alt="Login Logo" sx={{ width: "80%", maxWidth: 300 }} />
          </Grid>

          {/* Right Column: Login Form */}
          <Grid item xs={12} md={6}>
            <Paper elevation={0} sx={{ p: 4, maxWidth: 400, mx: "auto", boxShadow: "none", }}>
              <form onSubmit={handleSubmit}>
                <Typography variant="h5" gutterBottom style={{ fontFamily: "Poppins", textAlign: "center" }}>
                  {id} Login
                </Typography>

                {/* Email */}
                <TextField
                  label="Email Address"
                  type="email"
                  fullWidth
                  size="small"
                  margin="normal"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />

                {/* Password */}
                <TextField
                  label="Password"
                  type={hide ? "text" : "password"}
                  fullWidth
                  margin="normal"
                  required
                  size="small"
                  value={verifyPassword}
                  onChange={(e) => setVerifyPassword(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setHide(!hide)} edge="end">
                          {hide ? <FaEye /> : <FaEyeSlash />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                {/* Submit Button */}
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  sx={{ backgroundColor: "#f04b25", color: "#fff", mt: 2 }}
                >
                  Login
                </Button>
              </form>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
